
export enum BusinessUnitType {
  stores = 'STO',
  companies = 'COM',
  shoppingCenters = 'SHC',
  tradingServicesOffices = 'TSO',
  servicesOffices = 'SO',
  distributionCentersIMS = 'DTI',
  customerDistributionCenters = 'CDC',
  distributionCenters = 'DT',
  imsOffices = 'IMS',
  customerServiceCenters = 'CSC',
  businessServiceCenters = 'BSC',
  sharedServiceCenters = 'SSC',
  itOffices = 'ITO',
  propertySupportUnits = 'PSU',
  businessSupportUnits = 'BSU',
}

export const ALL_BUSINESSUNIT_TYPES: BusinessUnitType[] = Object.keys(BusinessUnitType).map(key => BusinessUnitType[key]);

/** Removes any prefix and ensure 5 digits */
export function make5Digits(businessUnit: string): string {
  if (!businessUnit) {
    return null;
  }

  if (businessUnit.includes('.')) {
    // eslint-disable-next-line prefer-destructuring
    businessUnit = businessUnit.split('.')[1];
  }

  if (Number.isNaN(+businessUnit)) {
    return null;
  }

  // add leading zeroes if missing
  return businessUnit.padStart(5, '0');
}

/** Removes any prefix and ensure 3 digits */
export function make3Digits(businessUnit: string): string {
  if (!businessUnit) {
    return null;
  }

  return make5Digits(businessUnit)?.slice(2);
}

/** Removes any prefix and ensure 3 digits */
export function make3DigitsWithPrefix(businessUnit: string): string {
  if (!businessUnit) {
    return null;
  }

  const prefix = businessUnit.includes('.') ? businessUnit.split('.')[0] : 'XXX';

  return `${prefix}.${make3Digits(businessUnit)}`;
}
